import React from 'react';
import T from 'components/T';
import { Document as DocumentType } from 'types/document';
import { dateIfDate } from '../../lib/formatting';
import Document from './Document';
import StoryText from './StoryText/StoryText';

interface CandidateStoryProps {
  story: {
    record?: {
      charge: string;
      location: string;
      offenseDate: Date;
    };
    content: string;
    documents: DocumentType[];
  };
}

const CandidateStory = ({ story }: CandidateStoryProps) => (
  <div
    className='candidate-story mb-3'
    data-testid='candidate-stories-general-information'
  >
    <h5
      className='d-flex mb-2 candidate-story-title'
      data-testid='candidate-story-title'
    >
      <strong className='text-uppercase'>
        {story.record ? (
          story.record.charge
        ) : (
          <T value='components.Report.CandidateStories.generalInformation' />
        )}
      </strong>
      {story.record && (
        <small className='ml-auto' data-testid='candidate-story-record-info'>
          {story.record.location}
          {story.record.offenseDate && (
            <span data-testid='candidate-story-offense-date'>
              &nbsp;&nbsp;•&nbsp;&nbsp;
              {dateIfDate(story.record.offenseDate)}
            </span>
          )}
        </small>
      )}
    </h5>

    <StoryText content={story.content} />

    {!!story.documents.length && (
      <div className='mb-4 mt-4' data-testid='candidate-story-documents'>
        {story.documents.map(document => (
          <Document
            document={document}
            key={`${document.name} - ${document.url}`}
          />
        ))}
      </div>
    )}
  </div>
);

export default CandidateStory;
